import React from 'react';

interface DocSpringIconProps {
  height?: number;
  className?: string;
}

export const DocSpringLogo: React.FC<DocSpringIconProps> = ({
  height = 26,
  className,
}) => {
  return (
    <svg
      height={height}
      width={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="32" height="32" rx="6" fill="#2563eb" />
      <path
        d="M8 10h16v2H8v-2zm0 4h16v2H8v-2zm0 4h12v2H8v-2zm0 4h8v2H8v-2z"
        fill="white"
      />
      <path d="M20 18l4 4-4 4v-8z" fill="white" />
    </svg>
  );
};
